import { render } from "./CriticalError.vue?vue&type=template&id=50b5a136"
import script from "./CriticalError.vue?vue&type=script&lang=js"
export * from "./CriticalError.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__